// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/no-cycle, no-restricted-imports
import { Dispatch } from '..';

// Types

export type DaysMap = {
  mapState: ('DAYS' | 'GROUPS') | null | undefined;
};
export type State = DaysMap;

type SetMapStateAction = {
  type: 'SET_MAP_STATE';
  mapState: ('DAYS' | 'GROUPS') | null | undefined;
};
export type Action = SetMapStateAction;

// Reducer

// eslint-disable-next-line import/no-default-export
export default function daysMapReducer(
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/default-param-last
  state: State = {
    mapState: null,
  },
  action: Action
) {
  switch (action.type) {
    case 'SET_MAP_STATE': {
      const { mapState } = action;
      return { ...state, mapState };
    }

    default:
      return state;
  }
}

// Actions

export const setMapState =
  (mapState: ('DAYS' | 'GROUPS') | null | undefined) => (dispatch: Dispatch) =>
    dispatch({
      type: 'SET_MAP_STATE',
      mapState,
    });
